module.exports = __webpack_public_path__ + "img/16581284_L.c1149cc3.png";